(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/jackpots.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/jackpots.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
svs.numbergames.results.models.Jackpot = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    defaultJackpot: false,
    jackpotAmountString: '',
    jackpotAmount: undefined,
    lotto1: {},
    lotto2: {},
    dromvinst: {}
  },
  initialize() {
    svs.numbergames.results.jackpotsRadio.reply('jackpotInfo', attributeKey => this.get(attributeKey));
  },
  parse(attrs) {
    var _attrs$;
    if (Array.isArray(attrs) && svs.numbergames.productMapping.isLotto((_attrs$ = attrs[0]) === null || _attrs$ === void 0 ? void 0 : _attrs$.productId)) {
      const _attrs = _slicedToArray(attrs, 3),
        lotto1 = _attrs[0],
        lotto2 = _attrs[1],
        dromvinst = _attrs[2];
      return {
        lotto1,
        lotto2,
        dromvinst
      };
    }
    return {
      defaultJackpot: attrs.defaultJackpot,
      jackpotAmountString: attrs.jackpotAmountString,
      jackpotAmount: attrs.jackpotAmount
    };
  }
});

 })(window);